"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ASSET_PREFIX } from "@/config"; 
import EnquireNowButton from "./EnquireNowButton";

export default function VideoPopupGallery() {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  // 🎬 Video Data
  const videos = [
 

    {
      id: 1,
      thumbnail: "/images/plusvilla-tvsnagar.webp",
      youtubeUrl: "https://www.youtube.com/watch?v=YP11D6U6oKs",
      title: "+Willa'25 - Strategically Located Villas at TVS Nagar, Thadagam Road",
    },
     {
      id: 2,
      thumbnail: "/images/pluswilla-transformation.webp",
      youtubeUrl: "https://www.youtube.com/watch?v=ZDbRRudtu14",
      title: "+Willa 25 transformation THEN. TODAY. TOMORROW.",
    },
    {
      id: 3,
      thumbnail: "/images/explore-pluswilla-walkthrough-video.webp",
      youtubeUrl: "https://www.youtube.com/watch?v=Mr5ROpdIgvs",
      title: "Explore +Willa 25 - Walkthrough Video",
    },

    // {
    //   id: 14,
    //   thumbnail: "/images/willa-just-move-in-media.webp",
    //   youtubeUrl:
    //     "https://www.youtube.com/watch?si=u6-3uEvOvLAqqZPa&v=rLS3DCOQnEY&feature=youtu.be",
    //   title: "+Willa - Construction Progress Video",
    // },
    // {
    //   id: 13,
    //   thumbnail: "/images/plus-willa-new-standard-2025.webp",
    //   youtubeUrl: "https://www.youtube.com/watch?v=Zn_QhstxEds",
    //   title:
    //     "Spotlight Interview -  +Willa, A new name & a new standard for modern life!",
    // },
    // {
    //   id: 12,
    //   thumbnail:
    //     "/images/excellence-in-value-innovation-in-real-estate-2025.webp",
    //   youtubeUrl: "https://www.youtube.com/watch?v=oqtf63EpANc",
    //   title:
    //     "Excellence in Value Innovation in Real Estate - Times Business Awards, Coimbatore - 2025",
    // },

    // {
    //   id: 11,
    //   thumbnail: "/images/introducing-willa-25.webp",
    //   youtubeUrl: "https://www.youtube.com/watch?v=djYnJ9-CWOY",
    //   title: "Introducing +Willa 25 - Coimbatore's 1st +Willa - JUST MOVE IN",
    // },
    // {
    //   id: 10,
    //   thumbnail: "/images/just-move-in-thumbnail.webp",
    //   youtubeUrl: "https://www.youtube.com/watch?v=DRGxz_QNrBk&t=25s",
    //   title: "PlusWilla25 - Project location video",
    // },
    // {
    //   id: 9,
    //   thumbnail: "/images/where-comfort-meets-complete-living.webp",
    //   youtubeUrl: "https://www.youtube.com/watch?v=t7fMiez35Wg&t=13s",
    //   title: "Discover Plus Willa 25 - Where Comfort Meets Complete Living",
    // },
    ///
  ];

  // 🎥 Convert YouTube URL to embed link
  const getYouTubeEmbedUrl = (url: string) => {
    const videoId = url.split("v=")[1]?.split("&")[0] || "";
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  return (
    <section className=" mx-auto max-w-[130rem] ">
      <div className="w-[85%] mx-auto">
      <div className="flex justify-between w-full mb-[70px] flex-wrap gap-[20px]">
        <h2 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[500] tracking-[-0.09em]  ">
          Our Media
        </h2>

        <div className="flex items-center flex-wrap gap-[15px]">
           <EnquireNowButton buttonText="Discover Pluswilla" />
        {/* <Link
          className="group text-[#000] hover:text-[#fff] bg-[#fff] border border-[#000] rounded-[50px] px-[20px] md:px-[25px] py-[8px] md:py-[12px] w-fit gap-[15px] flex items-center justify-between  transition-all duration-300 hover:bg-[#AF8E43] hover:border-[#AF8E43] cursor-pointer"
          href="/media">
          View all
          <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="https://www.w3.org/2000/svg"
            className="transition-transform duration-300 group-hover:rotate-45">
            <path
              d="M15.435 1.56497C15.435 1.01269 14.9873 0.564971 14.435 0.564971L5.43503 0.564972C4.88274 0.564971 4.43503 1.01269 4.43503 1.56497C4.43503 2.11726 4.88274 2.56497 5.43503 2.56497L13.435 2.56497L13.435 10.565C13.435 11.1173 13.8827 11.565 14.435 11.565C14.9873 11.565 15.435 11.1173 15.435 10.565L15.435 1.56497ZM1 15L1.70711 15.7071L15.1421 2.27208L14.435 1.56497L13.7279 0.857865L0.292893 14.2929L1 15Z"
              fill="#000"
              className="group-hover:fill-[#fff]"></path>
          </svg>
        </Link> */}
        </div>
      </div>

      {/* 🎞️ Swiper Carousel */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        spaceBetween={30}
        slidesPerView={3}
        onSwiper={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
        breakpoints={{
          0: {
            slidesPerView: 1.2,
            pagination: {
              enabled: true,
              el: ".custom-pagination",
              clickable: true,
            },
            navigation: { enabled: true },
          },
          640: {
            slidesPerView: 2,
            pagination: {
              enabled: true,
              el: ".custom-pagination",
              clickable: true,
            },
            navigation: { enabled: true },
          },
          1024: {
            slidesPerView: 3,
            pagination: {
              enabled: true,
              el: ".custom-pagination",
              clickable: true,
            },
            navigation: { enabled: true },
          },
        }}
        className="video-swiper">
        {videos.map((video) => (
          <SwiperSlide key={video.id}>
            <div
              className="relative cursor-pointer group overflow-hidden rounded-2xl max-h-[320px]"
              onClick={() => setActiveVideo(video.youtubeUrl)}>
              <Image
                src={`${ASSET_PREFIX}${video.thumbnail}`}
                alt={video.title}
                width={600}
                height={400}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />

              {/* Play Button Overlay */}
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                <svg
                  xmlns="https://www.w3.org/2000/svg"
                  className="h-16 w-16 text-white opacity-90 group-hover:scale-110 transition-transform"
                  fill="currentColor"
                  viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>

            {/* 🟨 OUTSIDE THE BOX */}
            <h3 className="text-[18px] leading-[28px] mt-[18px] font-[500] mb-[15px] tracking-[-0.03em] text-[#000] max-[1440px]:text-[18px] max-[1440px]:leading-[28px]">
              {video.title}
            </h3>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Pagination & Navigation (Visible only on small screens) */}
      <div className="mt-6 flex sm:hidden justify-between max-lg:justify-center items-end h-[45px]  gap-4  w-full  ">
        <button
          className={`custom-prev p-[5px] border-2 border-[#000] flex items-center justify-center rounded-full transition-opacity duration-300
    ${
      isBeginning
        ? "opacity-50 pointer-events-none cursor-default"
        : "opacity-100 cursor-pointer"
    }
  `}
          aria-label="Previous media">
          <svg
            xmlns="https://www.w3.org/2000/svg"
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <div className="custom-pagination flex gap-[6px] items-end justify-center swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
        <button
          className={`custom-next p-[5px] border-2 border-[#000] flex items-center justify-center rounded-full transition-opacity duration-300
    ${
      isEnd
        ? "opacity-50 pointer-events-none cursor-default"
        : "opacity-100 cursor-pointer"
    }
  `}
          aria-label="Next media">
          <svg
            xmlns="https://www.w3.org/2000/svg"
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2">
            <path d="M9 6l6 6-6 6" />
          </svg>
        </button>
      </div>

      {/* 🎥 Popup Modal */}
      <AnimatePresence>
        {activeVideo && (
          <motion.div
            key="popup"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-[999]"
            onClick={() => setActiveVideo(null)}>
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
              className="relative w-[90%] max-w-[900px] aspect-video bg-black rounded-xl overflow-hidden">
              <iframe
                src={getYouTubeEmbedUrl(activeVideo)}
                title="YouTube video"
                allow="autoplay; fullscreen"
                allowFullScreen
                className="w-full h-full"></iframe>

              {/* Close Button */}
              <button
                onClick={() => setActiveVideo(null)}
                className="absolute top-3 right-3 bg-white/20 hover:bg-white/40 text-white rounded-full w-10 h-10 flex items-center justify-center text-xl cursor-pointer">
                ✕
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      </div>
    </section>
  );
}
